import React from 'react'
import { Form, Spinner } from 'react-bootstrap'
//import HeaderData from '../Form/HeaderData.jsx'
import PositionList from '../Form/PositionList.jsx'
import { useLocalReceiptDataState } from '../../../stores/LocalReceiptDataProvider.js'
import MetaInfoBlock from '../Form/MetaInfoBlock.jsx'

const StoreReceiptContentArea = () => {
  const {
    formErrors,
    headerData,
    resetErrorByFormKey,
    positions,
    loadedReceiptData,
    addPosition,
    copyPosition,
    splitPosition,
    setPositions,
    actionMode
  } = useLocalReceiptDataState()
  return (
    <Form>
      {
        !loadedReceiptData
          ?
          <div className="d-flex align-items-center justify-content-center">< Spinner animation='border' variant='primary' /></div >
          :
          <>
            <div className='container-fluid'>
            <MetaInfoBlock headerData={headerData}/>
            <div className="mb-5" />
            <PositionList actionMode={actionMode} addPosition={addPosition} copyPosition={copyPosition} splitPosition={splitPosition} positions={positions} setPositions={setPositions} formErrors={formErrors} resetErrorByFormKey={resetErrorByFormKey} />
            </div>
          </>
      }
    </Form>
  )

}

export default StoreReceiptContentArea

